import axios from 'axios'
import { put, call, take, select, all, takeLatest } from 'redux-saga/effects'
import { articleActions, articleTypes } from 'features/articles'
import { revisionActions, revisionTypes } from '.'

const getArticleId = state => state.articles.article.id

function* getRevisionsRequest() {
	try {
		let articleId = yield select(getArticleId)

		if (!articleId) {
			yield take(articleTypes.GET_ARTICLE_SUCCESS)
		}

		articleId = yield select(getArticleId)

		const { data } = yield call(
			axios.get,
			`articles/${articleId}/revisions`
		)

		yield put(revisionActions.getRevisionsSuccess(data))
	} catch (e) {
		//
	}
}

function* getRevisionRequest({ id }) {
	try {
		const { data } = yield call(axios.get, `revisions/${id}`)

		yield put(revisionActions.getRevisionSuccess(data))
	} catch (e) {
		//
	}
}

function* restoreRevisionRequest({ id }) {
	try {
		const articleId = yield select(getArticleId)

		yield call(axios.get, `revisions/${id}/restore`)
		yield all([
			put(articleActions.getArticleRequest(articleId)),
			put(articleActions.getArticlesRequest()),
		])
	} catch (e) {
		//
	}
}

const revisionSagas = [
	takeLatest(revisionTypes.GET_REVISIONS_REQUEST, getRevisionsRequest),
	takeLatest(revisionTypes.GET_REVISION_REQUEST, getRevisionRequest),
	takeLatest(revisionTypes.RESTORE_REVISION_REQUEST, restoreRevisionRequest),
]

export default revisionSagas
